module.exports = __webpack_public_path__ + "img/sign-big.5a5e17b5.png";